import {useState, useEffect} from 'react'
import {ClockContainer, Heading, ClockImage, Time} from './styledComponents'

const Clock = () => {
  const [date, setDate] = useState(new Date())

  useEffect(() => {
    // eslint-disable-next-line
    const timerId = setInterval(() => {
      setDate(new Date())
    }, 1000)
    console.log('effect called and interval scheduled')
    return () => {
      clearInterval(timerId)
      console.log('clear Interval Called')
    }
  }, [])
  return (
    <ClockContainer>
      <Heading>Clock</Heading>
      <ClockImage
        src="https://assets.ccbp.in/frontend/hooks/clock-img.png"
        alt="clock"
      />
      <Time>{date.toLocaleTimeString()}</Time>
    </ClockContainer>
  )
}

export default Clock
